<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top :head-title=headTitle goBack="true"></head-top>


	</div>
</template>

<script>
	import headTop from "@/components/common/head.vue";
	import api from "@/apis/api";
	import tool from "@/common/tool";
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "CurriculumBind",
		components: {
			headTop: headTop,
		},
		data() {
			return {
				headTitle: '文武网课-扫码绑课', //标题
				resourceDomain: api.resourceDomain,
                curriculumId: null,
								skuId:null
			};
		},
		created() {},
		activated() {
            this.curriculumId = this.$route.query.curriculumId
						this.skuId = this.$route.query.skuId
			// 获取地区
			this.bindCurriculum(this.curriculumId,this.skuId)
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							this.bindCurriculum(this.curriculumId,this.skuId)
						},
						
            // 绑定课程
            bindCurriculum(curriculumId,skuId){
                api.postJson('/curriculum/bindCurriculum', {
                    id: skuId,
										curriculumId:curriculumId
                }).then((r)=>{
                    if(r.success){
                        this.$dialog.alert({
                        title: '温馨提示',
                        message: '课程绑定成功！',
                        showCancelButton: true,
                        cancelButtonText: '首页',
                        cancelButtonColor:'#8263F3',
                        confirmButtonText: '我的课程',
                        confirmButtonColor:'#38F',
                        }).then(() => {
                            this.$router.push({
                                'path': '/my_curriculum',
                            })
                        }).catch(() => {
                            this.$router.push({
                                'path': '/main/curriculum_index',
                            })
                        });
                    } else {
                        this.$dialog.alert({
                            title: '温馨提示',
                            message: r.message,
                        }).then(() => {
                            this.$router.push({
                                'path': '/main/curriculum_index',
                            })                            
                        })
                    }
                })
            }
		},
	};
</script>

